//  export const GetJsonAPI='http://localhost:8080/todStructure'
 export const GetJsonAPI = "https://figmaapi-erg9hsdmcbaehgcz.westus-01.azurewebsites.net/todStructure";
